module.exports = __webpack_public_path__ + "first-200-microprint.jpg?ecd98f749bfe5ddbc67164c10dc0f575";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200-microprint.jpg
// module id = 473
// module chunks = 0